// extracted by mini-css-extract-plugin
export var badge = "IconButton-module--badge--44eda";
export var base = "IconButton-module--base--41015";
export var button = "IconButton-module--button--b24c0";
export var filled = "IconButton-module--filled--f9d53";
export var key = "IconButton-module--key--1956b";
export var lighted = "IconButton-module--lighted--9ee23";
export var s = "IconButton-module--s--16822";
export var shadow = "IconButton-module--shadow--1f753";
export var solid = "IconButton-module--solid--c0770";
export var subtle = "IconButton-module--subtle--83fe4";
export var text = "IconButton-module--text--efcd6";
export var weak = "IconButton-module--weak--de607";